import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import { EventEmitter } from 'events';
import classNames from 'classnames';
import config from '../../../../../../config';
import { t } from '../../../../../../modules/infra/i18n';
import { APPOINTMENT_STATUS } from '../../../constants';
import {
  isLastRecurring,
  isPaidOnlineFailed,
} from '../../../../../common/helpers/appointments';
import manImage from '../../../../../../../images/man.png';
import manOffImage from '../../../../../../../images/man-off.png';
import recurrImage from '../../../../../../../images/three-circling-arrows.svg';
import lastRecurrImage from '../../../../../../../images/end-recurring.png';
import newCustomerImage from '../../../../../../../images/new-customer-image-2.png';
import notesImage from '../../../../../../../images/notes-image.png';
import failedPayment from '../../../../../../../images/failed-payment.png';
import randomImage from '../../../../../../../images/random.png';
import { fullName } from '../../../../../common/helpers/users';
import { isCustomerBlockedFromBooking } from '../../../../customers/customerForm/helpers';
import blockedCustomerIcon from '../../../../../../../images/block-client.svg';
import getStatusNameAndClass from '../../getStatusNameAndClass';

class TableRow extends Component {
  emitEvent = () => {
    EventEmitter.prototype.emit('appointment-clicked', this.props.appointment);
  };

  render() {
    const { appointment, counter, timezone, user } = this.props;
    const status = getStatusNameAndClass(appointment);
    const className = classNames('c-appointment-details', {
      'c-appointment-details--striped': appointment.status === APPOINTMENT_STATUS.canceled,
    });
    const {
      start,
      end,
      isRecurring,
      recurrUntil,
      isNewShopCustomer,
      isNewBarberCustomer,
      customerNotes,
      payment,
      bookedWithAnyBarber,
    } = appointment;
    const timeFrom = moment(start).tz(timezone).format(config.timeFormat);
    const timeTo = moment(end).tz(timezone).format(config.timeFormat);

    let customerIcons = [];
    if (moment().isBefore(moment(appointment.end)) && appointment.status !== APPOINTMENT_STATUS.canceled) {
      if (appointment.noShow) {
        customerIcons = [
          <span className="c-info-tooltip-new-handler" key={1}>
            <img
              className="appointment-list-icon"
              src={manOffImage}
              role="presentation"
            />
            <div className="c-info-tooltip-new__content">{t('appointment:calendar.tooltips.customer_no_show')}</div>
          </span>,
        ];
      } else if (appointment.status === APPOINTMENT_STATUS.arrived) {
        customerIcons = [
          <span className="c-info-tooltip-new-handler" key={1}>
            <img
              className="appointment-list-icon"
              src={manImage}
              role="presentation"
            />
            <div className="c-info-tooltip-new__content">{t('appointment:calendar.tooltips.customer_arrived')}</div>
          </span>,
        ];
      }

      if (isRecurring && isLastRecurring(moment(start), moment(recurrUntil))) {
        customerIcons.push(
          <img
            className="appointment-list-icon"
            src={lastRecurrImage}
            role="presentation"
            key={2}
          />
        );
      } else if (isRecurring) {
        customerIcons.push(
          <img
            className="appointment-list-icon"
            src={recurrImage}
            role="presentation"
            key={2}
          />
        );
      }

      if (isPaidOnlineFailed(payment)) {
        customerIcons.push(
          <img
            className="appointment-list-icon"
            src={failedPayment}
            role="presentation"
            key={3}
          />
        );
      }

      if (customerNotes) {
        customerIcons.push(
          <img
            className="appointment-list-icon"
            src={notesImage}
            role="presentation"
            key={4}
          />
        );
      }

      if (isNewBarberCustomer || isNewShopCustomer) {
        customerIcons.push(
          <img
            className="appointment-list-icon"
            src={newCustomerImage}
            role="presentation"
            key={5}
          />
        );
      }

      if (bookedWithAnyBarber) {
        customerIcons.push(
          <img
            className="appointment-list-icon"
            src={randomImage}
            role="presentation"
            key={6}
          />
        );
      }
    }

    if (isCustomerBlockedFromBooking({
      userKind: user.kind,
      customer: appointment.customer,
      barberId: appointment.barberId,
      shopId: appointment.shopId,
      brandId: appointment.shop.brandId,
    })) {
      customerIcons.push(
        <img
          className="appointment-list-icon"
          alt={t('appointment:calendar.tooltips.blocked_client')}
          title={t('appointment:calendar.tooltips.blocked_client')}
          src={blockedCustomerIcon}
          key={7}
        />
      );
    }

    return (
      <div
        className={className}
        onClick={this.emitEvent}
      >
        <div className="c-appointment-details__col">
          <div
            className="c-round-number"
            style={{ backgroundColor: appointment.barberColor }}
            data-automation-id={`text:appointmentNumber:${appointment.id}`}
          >
            {counter}
          </div>
        </div>
        <div
          className="c-appointment-details__col c-appointment-details__col--small"
          data-automation-id={`text:appointmentTimes:${appointment.id}`}
        >
          <span className="large-and-up-p--">{timeFrom} - {timeTo}</span>
        </div>
        <div
          className="c-appointment-details__col"
          data-automation-id={`text:appointmentCustomerName:${appointment.id}`}
        >
          { appointment.customerFullName }
          { customerIcons }
        </div>
        <div
          className="c-appointment-details__col u-mt-- large-and-up-mt0"
          data-automation-id={`text:appointmentDescription:${appointment.id}`}
        >
          {appointment.description}
        </div>
        <div
          className="c-appointment-details__col"
          data-automation-id={`text:appointmentBarberName:${appointment.id}`}
        >
          {fullName(appointment.barber)}
        </div>
        <div className="c-appointment-details__col c-appointment-details__col--status">
          <div
            className={`c-status ${status.statusClass}`}
            data-automation-id={`text:appointmentStatus:${appointment.id}`}
          >
            {status.statusName}
          </div>
        </div>
      </div>
    );
  }
}

TableRow.propTypes = {
  counter: PropTypes.number.isRequired,
  appointment: PropTypes.object.isRequired,
  timezone: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  timezone: state.auth.timezone,
  user: state.auth.user,
});

export default connect(mapStateToProps, null)(TableRow);
